import Opcoes from "./components/opcoes.vue"
import Home from "./components/Home.vue"

export const routes = [
    { path: '', component: Home, name: 'Home' },
    { path: '/opcoes', component: Opcoes, name: 'Opcoes' },
  ];